const LogonoText = (props: { className: string }) => {
  return (
    <svg {...props} viewBox="0 0 57 56">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        {...props}
        d="M4.464 18.71c-5.133 5.131-5.133 13.449 0 18.58l14.868 14.862c5.133 5.13 13.454 5.13 18.586 0L52.787 37.29c5.132-5.13 5.132-13.448 0-18.579L37.918 3.848c-5.133-5.13-13.454-5.13-18.586 0L4.464 18.71ZM35.13 34.503a9.193 9.193 0 0 0 0-13.006 9.2 9.2 0 0 0-13.01 0 9.193 9.193 0 0 0 0 13.006 9.202 9.202 0 0 0 13.01 0Z"
      ></path>
    </svg>
  );
};
export default LogonoText;
